/* global Razorpay */
import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  Upload,
  DatePicker,
  Space,
  Row,
  Col,
  message,
  Modal,
  Tag,
  Tooltip,
  Spin,
  Skeleton,
} from "antd";
import {
  PlusOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { fetchCustomers } from "../customer/FetchCustomers";
import OrderItems from "../orderItems/OrderItems";
import { fetchOrders } from "./FetchOrders";
import CustomerAddress from "../customerAddress/CustomerAddress";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { fetchCoupons } from "../coupons/fetchCoupons";
import PDFViewer from "../pdfviewer/PDFViewer";
import Highlighter from "react-highlight-words";
import { devUrl, token } from "../../constants/Constants";
import PointOfContact from "../poc/PointOfContact";
import { addReportToPatient, cancelOrderById, createAdminOrder, fetchReport, fetchTransactions, getCustomerDetails, getOrderById, getOrderItemsByCustomer, updateOrderById } from "../../endpoints/API";

const { Option } = Select;

const formatDateTime = (datetime) => {
  const dateObj = new Date(datetime);

  // Format date as dd mm yyyy
  const formattedDate = dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  // Format time in 12-hour format
  const formattedTime = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return { formattedDate, formattedTime };
};

const Order = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const user = useSelector((state) => state.user.user);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customerData, setCustomerData] = useState(null);
  const [selectedCustomerProfile, setSelectedCustomerProfile] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [orderItems, setOrderItems] = useState([]);
  const [orders, setOrders] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [form] = Form.useForm(); // Create a form instance
  const [isEditMode, setIsEditMode] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [viewOrderItemsModalVisible, setViewOrderItemsModalVisible] =
    useState(false);
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [cancellationReason, setCancellationReason] = useState("");
  const [cancelOrderModalVisible, setIsCancelOrderModalVisible] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0); // Order total amount
  const [appliedCoupon, setAppliedCoupon] = useState(null); // Currently applied coupon
  const [originalAmount, setOriginalAmount] = useState(0);
  const [originalB2CAmount, setOriginalB2CAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [isOrderNumber, setIsOrderNumber] = useState();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [isPOCModalVisible, setIsPOCModalVisible] = useState("");

  const dataSourceOrder = orders?.map((item) => {
    const fullName = `${item.point_of_contact}`;
    const phoneNumber = item.point_of_contact?.phone || "";

    return {
      id: item.order_id,
      order_number: item.order_number,
      customer: item.customer,
      order_status: item.status,
      place_datetime: item.place_datetime,
      schedule_datetime: item.schedule_datetime,
      location: (
        <>
          <Tooltip title={<>{item.address}</>}>
            <Tag>Address</Tag>
          </Tooltip>

          {/* <div>
            {`${item.location.house_flat_floor_no} ${item.location.apartment_road_area} ${item.location.city.name} ${item.location.state.name} ${item.location.pincode?.pin} ${item.location.country.name}`}
          </div> */}
        </>
      ),
      otp: <Tag color="blue">{item.otp}</Tag>,
      point_of_contact_search: `${fullName} ${phoneNumber}`, // Store combined text for search
      point_of_contact: (
        <>
          <Tag>{fullName}</Tag>
          <Tag>{phoneNumber}</Tag>
        </>
      ),
      order_item: item.order_items,
      transactions: item.transactions?.map(
        (transaction) => transaction?.invoice_pdf
      ),
      cancellation_reason: item.cancellation_reason,
      cancelled_date_time: item.cancelled_date_time,
      cancelled_by: item?.cancelled_by ? item.cancelled_by : "-",
    };
  });

  const showInvoiceModal = (transactions) => {
    setSelectedTransactions(transactions);
    setInvoiceModalVisible(true);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const openInvoicePDF = (transactions) => {
    const pdfUrl = `${prodTestUrl ? prodTestUrl : baseUrl}${transactions}`;

    if (pdfUrl) {
      // Open PDF in new tab
      window.open(pdfUrl, "_blank");
    } else {
      console.error("Invoice PDF URL is not available");
    }
  };

  const handleInvoiceModalClose = () => {
    // Handle the logic for creating a new order item here
    setInvoiceModalVisible(false);
  };

  const handleInvoiceModalOk = () => {
    // Handle the logic for creating a new order item here
    setInvoiceModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    // Handle the logic for creating a new order item here
    setIsModalVisible(false);
  };

  const handleAdressModalOk = () => {
    // Handle the logic for creating a new order item here
    setShowAddressModal(false);
  };

  const showModalPOC = () => {
    setIsPOCModalVisible(true);
  };

  const fetchCustomerData = async () => {
    if (selectedCustomerProfile) {
      try {
        const response = await getOrderItemsByCustomer(selectedCustomerProfile);

        if (!response.statusText == "OK") {
          throw new Error("Network response was not ok");
        }

        const data = response?.data;
        setOrderItems(data); // Set order items based on customer ID
      } catch (error) {
        message.error(error?.response?.data?.error || "Error fetching order items");
      }
    }
  };

  useEffect(() => {
    fetchCustomerData();
  }, [selectedCustomerProfile]);

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handlePOCModalCancel = () => {
    setIsPOCModalVisible(false);
  };

  const handleAddressModalCancel = () => {
    setShowAddressModal(false);
  };

  useEffect(() => {
    const getCustomerData = async () => {
      setIsLoading(true);

      try {
        await fetchCustomers(setCustomers, baseUrl, prodTestUrl);
        await fetchOrders(setOrders, baseUrl, prodTestUrl);
        await fetchCoupons(setCoupons, baseUrl, prodTestUrl);
      } catch (error) {
        message.error(error?.response?.data?.error || "Failed to fetch data.");
      } finally {
        setIsLoading(false);
      }
    };

    getCustomerData();
  }, []);

  useEffect(() => {
    const fetchCustomerData = async () => {
      if (selectedCustomerProfile) {
        try {
          const response = await getCustomerDetails(selectedCustomerProfile);

          if (!response.statusText == "OK") {
            throw new Error("Network response was not ok");
          }

          const data = response?.data;
          setIsLoading(true);
          setCustomerData(data);
        } catch (error) {
          message.error(error?.response?.data?.error || "Error fetching customer data");
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchCustomerData();
  }, [selectedCustomerProfile]);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  const handleEdit = async (record) => {
    setIsLoading(true);
    try {
      // Fetch order details from backend using the order ID
      const response = await getOrderById(record.id);

      if (!response.statusText == "OK") {
        throw new Error("Failed to fetch order details");
      }

      const orderData = response?.data;

      // Set edit mode and store the record being edited
      setIsEditMode(true);
      setEditRecord(record);
      setIsFormVisible(true);

      // Set the customer profile to fetch related data
      setSelectedCustomerProfile(orderData.order.customer.id);

      // Wait for customer data to load before setting form values
      await fetchCustomerData();

      // Extract relevant data from orderData
      const order = orderData.order;
      const orderItems = order.order_item || [];
      const pointOfContact = order.point_of_contact;
      const location = order.location;
      const couponApplied = order.coupon_applied;

      // Calculate total amounts
      const totalFrp = orderItems.reduce((sum, item) => {
        const testMrp = item.test?.mrp ? parseFloat(item.test.mrp) : 0;
        const packageMrp = item.package?.mrp ? parseFloat(item.package.mrp) : 0;
        return sum + testMrp + packageMrp;
      }, 0);

      const totalB2CAmount = orderItems.reduce((sum, item) => {
        const testB2C = item.test?.b2c_price
          ? parseFloat(item.test.b2c_price)
          : 0;
        const packageB2C = item.package?.b2c_price
          ? parseFloat(item.package.b2c_price)
          : 0;
        return sum + testB2C + packageB2C;
      }, 0);

      // Set the original amounts for coupon calculations
      setOriginalAmount(totalFrp);
      setOriginalB2CAmount(totalB2CAmount);
      setTotalAmount(order.amount || totalB2CAmount);

      // Set applied coupon if exists
      if (couponApplied) {
        setAppliedCoupon(couponApplied);
      }

      // Prefill the form fields with the fetched order data
      form.setFieldsValue({
        customer: order.customer?.id,
        orderItems: orderItems.map((item) => item.id),
        point_of_contact: pointOfContact?.id,
        scheduleOrder: order.schedule_datetime
          ? moment(order.schedule_datetime)
          : null,
        location: location?.id,
        amount:
          orderData.transactions?.map((txn) => txn.price) ||
          totalB2CAmount.toFixed(2),
        coupon: couponApplied?.id || null,
      });
    } catch (error) {
      message.error(error?.response?.data?.error || "Failed to load order details for editing");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelOrder = async () => {
    if (!cancellationReason.trim()) {
      message.error("Cancellation reason is required.");
      return;
    }

    try {
      // Replace with your API endpoint and adjust request as needed
      const payload = {
        status: "cancelled",
        reason: cancellationReason,
        user: "admin",
        userID: user.user_id,
      };

      const response = await cancelOrderById(selectedOrderId, payload);

      if (response.statusText == "OK") {
        message.success("Order cancelled successfully.");
        setIsCancelOrderModalVisible(false);
        setCancellationReason("");
        setSelectedOrderId(null);
        await fetchOrders(setOrders, baseUrl, prodTestUrl);

        // Optionally, refresh orders here
      } else {
        const error = response?.data;
        message.error(error.message || "Failed to cancel the order.");
      }
    } catch (error) {
      message.error(error?.response?.data?.error || "Something went wrong. Please try again.");
    }
  };

  const handleFinish = async (values) => {
    const payload = {
      customer: values.customer,
      orderItems: values.orderItems,
      point_of_contact: values.point_of_contact,
      schedule_datetime: values.scheduleOrder.format("YYYY-MM-DD HH:mm:ss"),
      location: values.location,
      amount: values.amount,
      total_frp: originalAmount,
      total_b2c_amount: originalB2CAmount,
      coupon_applied: values.coupon,
    };

    try {
      if (isEditMode && editRecord) {
        // Update existing order
        const response = await updateOrderById(editRecord.id, payload);

        const data = response?.data;

        if (!response.statusText == "OK") {
          throw new Error(data.message || "Failed to update order");
        }

        message.success("Order updated successfully");
        setIsFormVisible(false);
        setIsEditMode(false);
        setEditRecord(null);
        await fetchOrders(setOrders, baseUrl, prodTestUrl);
      } else {
        // Create new order (existing Razorpay logic)
        const orderResponse = await createAdminOrder(payload);
        const orderData = orderResponse?.data;

        if (orderResponse.statusText == "OK") {
          message.success("Order placed successfully");
          setIsFormVisible(false);
          await fetchOrders(setOrders, baseUrl, prodTestUrl);

          return orderData;
        } else {
          throw new Error(orderData.message || "Failed to create order");
        }

        // Razorpay payment flow for new orders
        // const options = {
        //   key: "rzp_test_nDqmupHpKKwbNT",
        //   amount: payload.amount * 100,
        //   currency: "INR",
        //   name: orderData?.order?.customer?.first_name + " " +
        //         (orderData?.order?.customer?.middle_name ?
        //          orderData?.order?.customer?.middle_name : "") + " " +
        //         orderData?.order?.customer?.last_name,
        //   description: "Order Payment",
        //   order_id: orderData.order_number,
        //   notes: {
        //     address: orderData.location || "N/A",
        //   },
        //   theme: {
        //     color: "#3399cc",
        //   },
        //   handler: async function (response) {
        //     try {
        //       console.log("Payment Success Response:", response);
        //       message.success(`Payment Successful! Payment ID: ${response.razorpay_payment_id}`);
        //       setIsFormVisible(false);
        //       await fetchOrders(setOrders, baseUrl, prodTestUrl);
        //     } catch (error) {
        //       console.error("Error handling payment response:", error);
        //       message.error("An error occurred while processing the payment.");
        //     }
        //   },
        // };

        // const rzp1 = new Razorpay(options);
        // rzp1.on("payment.failed", function (response) {
        //   console.error("Payment Failed Response:", response);
        //   message.error("Payment failed. Please try again.");
        // });
        // rzp1.open();
      }
    } catch (error) {
      message.error(error?.response?.data?.error || "Something went wrong. Please try again.");
    }
  };

  const handleReportUpload = async (file, patientId, orderId) => {
    setIsLoading(true); // Show loading indicator

    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("report", file);
      formData.append("order_id", orderId);
      formData.append("order_patient_id", patientId.split("-")[1]); // Send just the patient ID part
      formData.append("order_id_patient_id", patientId);

      const response = await addReportToPatient(formData);

      if (!response.statusText == "OK") {
        const errorData = response?.data;
        throw new Error(errorData.message || "Failed to upload report");
      }

      const data = response?.data;

      // Show success message
      message.success("Report uploaded successfully!");

      // Refresh orders data to show the new report
      await fetchOrders(setOrders, baseUrl, prodTestUrl);

      return data;
    } catch (error) {
      message.error(error?.response?.data?.error || "Failed to upload report");
      throw error; // Re-throw for the Upload component to handle
    } finally {
      setIsLoading(false); // Hide loading indicator
    }
  };

  // const verifyPayment = async (response) => {
  //   try {
  //     const verifyResponse = await fetch(
  //       `${prodTestUrl ? prodTestUrl : baseUrl}/api/verify-payment/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           razorpay_payment_id: response.razorpay_payment_id,
  //           razorpay_order_id: response.razorpay_order_id,
  //           razorpay_signature: response.razorpay_signature,
  //         }),
  //       }
  //     );

  //     const result = await verifyResponse.json();
  //     console.log("Payment Verification Response:", result);

  //     if (verifyResponse.ok) {
  //       message.success("Payment Verified Successfully!");
  //     } else {
  //       message.error(result.message || "Payment verification failed.");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying payment:", error);
  //     message.error("Payment verification failed.");
  //   }
  // };

  const handleCancel = () => {
    setIsFormVisible(false);
  };

  const uploadProps = {
    beforeUpload: (file) => {
      console.log("Uploaded file:", file);
      return false; // Prevent automatic upload
    },
  };

  // const columns = [
  //   {
  //     title: "Family Member",
  //     dataIndex: "familyMemberName",
  //     key: "familyMemberName",
  //     render: (text) => text || "-",
  //   },
  //   {
  //     title: "Family Member Type",
  //     dataIndex: "familymembertype",
  //     key: "familymembertype",
  //     render: (text) => text || "-",
  //   },
  //   {
  //     title: "Test Name (MRP)",
  //     dataIndex: "testNameWithMrp",
  //     key: "testNameWithMrp",
  //     render: (text) => text || "-",
  //   },
  //   {
  //     title: "Package Name (MRP)",
  //     dataIndex: "packageNameWithMrp",
  //     key: "packageNameWithMrp",
  //     render: (text) => text || "-",
  //   },
  //   {
  //     title: "Test Requirement",
  //     dataIndex: "testRequirement",
  //     key: "testRequirement",
  //     render: (text) => text || "-",
  //   },
  //   {
  //     title: "Test Description",
  //     dataIndex: "testDescription",
  //     key: "testDescription",
  //     render: (text) => text || "-",
  //   },
  // ];

  // const dataSource = selectedOrderItems?.map((item, index) => ({
  //   key: index,
  //   familyMemberName:
  //     item.familymember.first_name +
  //     " " +
  //     (item.familymember.middle_name ? item.familymember.middle_name : "") +
  //     " " +
  //     item.familymember.last_name,
  //   testNameWithMrp: item?.test
  //     ? `${item.test.name} (₹${item.test.mrp})`
  //     : null,
  //   packageNameWithMrp: item?.package
  //     ? `${item.package.name_of_package} (₹${item.package.mrp})`
  //     : null,
  //   testRequirement: item?.test?.test_requirements?.map((req) => req?.name),
  //   testDescription: item?.test?.description
  //     ? item?.test?.description
  //     : "-" || item?.package?.description
  //     ? item?.package?.description
  //     : "-",
  //   familymembertype: <Tag>{item?.familymember?.family_member_type?.name}</Tag>,
  // }));

  // const handleViewReport = async (reportKey) => {
  //   try {
  //     console.log(reportKey); 
  //     const res = await fetchReport(`secured_media_access/${reportKey}/`);

  //     if (res.status !== 200 || !res.data?.url) {
  //       throw new Error("Failed to fetch report");
  //     }

  //     const fileUrl = res.data.url; // presigned URL
  //     window.open(fileUrl, "_blank");
  //   } catch (error) {
  //     console.error(error);
  //     message.error(error?.response?.data?.message || "Error fetching report");
  //   }
  // };
  const handleViewReport = async (reportUrl) => {
    try {
      const res = await fetchReport(`secured_media_access${reportUrl}/`);

      if (!res.statusText == "OK") throw new Error("Failed to fetch report");
      const blob = res?.data;
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      message.error(error?.response?.data?.error);
    }
  };


  const columns = [
    {
      title: "Patient ID",
      dataIndex: "patientid",
      key: "patientid",
      render: (text) => text || "-",
    },
    {
      title: "Patient Name",
      dataIndex: "familyMemberName",
      key: "familyMemberName",
      render: (text) => text || "-",
    },
    // {
    //   title: "Family Member Type",
    //   dataIndex: "familymembertype",
    //   key: "familymembertype",
    //   render: (text) => text || "-",
    // },
    {
      title: "Test Name (MRP)",
      dataIndex: "testNameWithMrp",
      key: "testNameWithMrp",
      // render: (text) => text || "-",
    },
    {
      title: "Package Name (MRP)",
      dataIndex: "packageNameWithMrp",
      key: "packageNameWithMrp",
      render: (text) => text || "-",
    },
    {
      title: "Report",
      dataIndex: "patientid",
      key: "patientid",
      render: (patientid, record) => {
        // Extract patient ID (format: "orderNumber-patientId")
        const patientIdOnly = patientid.split("-")[1];
        const orderId = patientid.split("-")[0];

        // Find the report for this patient
        const report = orders
          ?.flatMap((order) =>
            order?.order_items?.flatMap((item) => item?.reports || [])
          )
          ?.find((report) => report?.order_familymember_id === patientid);


        const reportUrl = report?.report_url;
        const absoluteUrl = reportUrl ? `${devUrl}${reportUrl}` : null;

        // Handle file upload
        const customRequest = async ({ file, onSuccess, onError }) => {
          try {
            await handleReportUpload(file, patientid, orderId);
            onSuccess();
          } catch (error) {
            onError(error);
          }
        };

        // Show "View" if report exists, else "Upload"
        return absoluteUrl ? (
          // <a href={absoluteUrl} rel="noopener noreferrer">
          //   <Button size="small">View</Button>
          // </a>
          <Button size="small" onClick={() => handleViewReport(reportUrl)}>
            View
          </Button>
        ) : (
          <Upload
            accept=".pdf"
            showUploadList={false}
            customRequest={customRequest}
            beforeUpload={(file) => {
              const isPDF = file.type === "application/pdf";
              if (!isPDF) {
                message.error("Only PDF files are allowed!");
                return false;
              }
              return true;
            }}
          >
            <Button size="small" icon={<UploadOutlined />}>
              Upload
            </Button>
          </Upload>
        );
      },
    },

    // {
    //   title: "Test Requirement",
    //   dataIndex: "testRequirement",
    //   key: "testRequirement",
    //   render: (text) => text || "-",
    // },
    // {
    //   title: "Test Description",
    //   dataIndex: "testDescription",
    //   key: "testDescription",
    //   render: (text) => text || "-",
    // },
    // {
    //   title: "Pouch",
    //   dataIndex: "pouch",
    //   key: "pouch",
    //   // render: (_, order_item) => console.log(order_item),
    // },
    // {
    //   title: "Pouch Item",
    //   dataIndex: "pouch_item",
    //   key: "pouch_item",
    //   render: (pouch_item) =>
    //     orders?.pouch_items
    //       ?.filter((item) => item?.pouch_id === pouch_item) // Filter based on pouch_id match
    //       ?.map((item) =>
    //         item?.lab_user_scan_time ? (
    //           <Tag color="orange">{item?.barcode}</Tag>
    //         ) : (
    //           <Skeleton.Input
    //             style={{ width: 50, marginTop: "5px" }}
    //             active={true}
    //           />
    //         )
    //       ), // Return item.barcode if match is found
    // },
    // {
    //   title: "Status",
    //   dataIndex: "patientid",
    //   key: "patientid",
    //   render: (patientid) =>
    //     orders?.accession_items
    //       ?.filter((item) => item?.order_patient_id === patientid) // Filter based on patientid match
    //       ?.map((item) => {
    //         if (item?.status === "partial") {
    //           return <Tag color="green">Partial Accession Started</Tag>;
    //         }
    //         if (item?.status === "complete") {
    //           return <Tag color="green">Accession Started</Tag>;
    //         }
    //         return null;
    //       }),
    // },
  ];

  // console.log(orders);

  const dataSource = selectedOrderItems?.map((item, index) => ({
    key: index,
    patientid: isOrderNumber + "-" + item.family_member_id,
    familyMemberName: item.family_member_name,
    testNameWithMrp: item?.test_name ? item.test_name : null,
    packageNameWithMrp: item?.package_name ? item.package_name : null,
    testRequirement: item?.test?.test_requirements?.map((req) => req?.name),
    testDescription: item?.test?.description
      ? item?.test?.description
      : "-" || item?.package?.description
        ? item?.package?.description
        : "-",
    familymembertype: <Tag>{item?.familymember?.family_member_type?.name}</Tag>,
    pouch: <Tag color="blue">{item?.pouch?.pouch_barcode}</Tag>,
    pouch_item: item?.pouch?.id,
  }));


  const handleViewOrderItems = (id, orderNumber, orderItems) => {
    setIsOrderNumber(orderNumber);

    setSelectedOrderItems(orderItems); // Set the selected order items
    setViewOrderItemsModalVisible(true); // Show the modal
  };

  const closeOrderItemsModal = () => {
    setViewOrderItemsModalVisible(false);
    setSelectedOrderItems([]);
  };

  const handleSelectOrderItem = (selectedItemIds) => {
    // Filter the selected items based on their IDs
    const selectedItems = orderItems.filter((item) =>
      selectedItemIds.includes(item.id)
    );

    // Calculate the total MRP of selected items
    const totalAmount = selectedItems.reduce((sum, item) => {
      const testMRP = item.test?.mrp ? parseFloat(item.test.mrp) : 0;
      const packageMRP = item.package?.mrp ? parseFloat(item.package.mrp) : 0;
      return sum + testMRP + packageMRP;
    }, 0);

    const totalB2CAmount = selectedItems.reduce((sum, item) => {
      const testMRP = item.test?.b2c_price
        ? parseFloat(item.test.b2c_price)
        : 0;
      const packageMRP = item.package?.b2c_price
        ? parseFloat(item.package.b2c_price)
        : 0;
      return sum + testMRP + packageMRP;
    }, 0);
    setOriginalB2CAmount(totalB2CAmount);

    setOriginalAmount(totalAmount); // Store the original amount
    setTotalAmount(totalAmount); // Set the total amount initially

    // Set the calculated amount into the "amount" input field
    form.setFieldsValue({ amount: totalB2CAmount.toFixed(2) });
  };

  const handleSelectCoupon = (couponId) => {
    const selectedCoupon = coupons?.data?.find(
      (coupon) => coupon?.id === couponId
    );

    if (!selectedCoupon) {
      message.error("Invalid coupon selected.");
      return;
    }

    const orderAmount = originalB2CAmount; // Use the original total amount

    // Check coupon conditions
    if (orderAmount < selectedCoupon.minimum_purchase_amount) {
      message.error("Minimum purchase amount not met for this coupon.");
      return;
    }

    const currentDate = new Date();
    const expiryDate = new Date(selectedCoupon.expiry);
    if (expiryDate < currentDate) {
      message.error("This coupon has expired.");
      return;
    }

    // Apply discount
    let discountedAmount = orderAmount;
    if (selectedCoupon.discount_type === "money") {
      discountedAmount = Math.max(
        0,
        orderAmount - parseFloat(selectedCoupon.discount_value)
      );
    } else if (selectedCoupon.discount_type === "percentage") {
      discountedAmount =
        orderAmount -
        (orderAmount * parseFloat(selectedCoupon.discount_value)) / 100;
    }

    setAppliedCoupon(selectedCoupon);
    setTotalAmount(discountedAmount);
    form.setFieldsValue({ amount: discountedAmount.toFixed(2) });

    message.success(`Coupon applied: ${selectedCoupon.code}`);
  };

  // const handleViewInvoice = async (transactions) => {
  //   try {
  //     const res = await fetchTransactions(
  //       `secured_media_access/${encodeURIComponent(transactions)}/`
  //     );

  //     if (res.status !== 200 || !res.data?.url) {
  //       throw new Error("Failed to fetch invoice");
  //     }

  //     const fileUrl = res.data.url;
  //     window.open(fileUrl, "_blank");
  //   } catch (error) {
  //     console.error(error);
  //     message.error(error?.response?.data?.message || "Could not open the invoice.");
  //   }
  // };

  const handleViewInvoice = async (transactions) => {
    try {
      const res = await fetchTransactions(`secured_media_access${transactions}/`);
      if (!res.statusText == "OK") throw new Error("Failed to fetch invoice");
      const blob = res?.data;
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      message.error(error?.response?.data?.error || "Could not open the invoice.");
    }
  };


  return (
    <Spin spinning={isLoading} tip="Loading...">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          {isFormVisible ? (
            <div className="flex gap-2 justify-end w-full">
              {/* <Button type="primary">Create Order Item</Button> */}
              <Button type="primary" onClick={toggleFormVisibility}>
                Cancel
              </Button>
            </div>
          ) : (
            <div className="flex gap-2 justify-end w-full">
              <Button type="primary" onClick={toggleFormVisibility}>
                Create Order
              </Button>
            </div>
          )}
        </div>

        {isFormVisible ? (
          <Form layout="vertical" onFinish={handleFinish} form={form}>
            <Form.Item
              label="Select Customer"
              name="customer"
              rules={[{ required: true, message: "Please select a customer" }]}
            >
              <Select
                placeholder="Select a customer"
                onChange={(value) => setSelectedCustomerProfile(value)}
                showSearch
                optionFilterProp="label" // Set optionFilterProp to "label"
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {customers?.map((customer) => (
                  <Select.Option
                    key={customer.id}
                    value={customer.id}
                    label={`${customer.first_name} ${customer.middle_name || ""
                      } ${customer.last_name} (${customer.email}) (${customer.phone
                      })`} // Use label
                  >
                    {customer.first_name} {customer.middle_name || ""}{" "}
                    {customer.last_name}
                    <span>({customer.email})</span>
                    <span>({customer.phone})</span>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <div className="flex w-full">
                  <div>Order Items</div>
                  <div className="ml-[.5rem]">
                    <Tooltip title="Add Order Items">
                      <PlusCircleOutlined onClick={showModal} />
                    </Tooltip>
                  </div>
                </div>
              }
              name="orderItems"
              rules={[{ required: true, message: "Please select order items" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select order items"
                onChange={(value, option) =>
                  handleSelectOrderItem(value, option)
                }
              >
                {orderItems?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item?.test ? (
                      <>
                        {item.test.name}{" "}
                        ({item.test.lab})
                        <span>
                          ({item?.familymember?.first_name || ""}
                          {item?.familymember?.middle_name
                            ? ` ${item.familymember.middle_name}`
                            : ""}
                          {item?.familymember?.last_name
                            ? ` ${item.familymember.last_name}`
                            : ""}
                          )
                        </span>
                      </>
                    ) : item?.package ? (
                      <>
                        {item.package.name_of_package}{" "}
                        ({item.package.lab})

                        <span>
                          ({item?.familymember?.first_name || ""}
                          {item?.familymember?.middle_name
                            ? ` ${item.familymember.middle_name}`
                            : ""}
                          {item?.familymember?.last_name
                            ? ` ${item.familymember.last_name}`
                            : ""}
                          )
                        </span>
                      </>
                    ) : null}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <div className="flex w-full">
                  <div>Point Of Contact</div>
                  <div className="ml-[.5rem]">
                    <Tooltip title="Add Point Of Contact">
                      <PlusCircleOutlined onClick={showModalPOC} />
                    </Tooltip>
                  </div>
                </div>
              }
              name="point_of_contact"
              rules={[
                {
                  required: true,
                  message: "Please provide a point of contact",
                },
              ]}
            >
              <Select placeholder="Add points of contact">
                {customerData?.point_of_contacts?.map((member) => (
                  <>
                    <Select.Option key={member.id} value={member.id}>
                      {`${member.first_name} ${member.last_name} - ${member.phone}`}
                    </Select.Option>
                  </>
                ))}
              </Select>
            </Form.Item>

            {/* <Form.Item
            label="Order Type"
            name="orderType"
            rules={[{ required: true, message: "Please select an order type" }]}
          >
            <Select placeholder="Select order type">
              <Option value="test">Test</Option>
              <Option value="package">Package</Option>
            </Select>
          </Form.Item> */}

            <Form.Item
              label="Schedule Order"
              name="scheduleOrder"
              rules={[{ required: true, message: "Please select a schedule" }]}
            >
              <DatePicker
                showTime={{ format: "hh:mm A" }} // 12-hour format with AM/PM
                placeholder="Select date and time"
                style={{ width: "100%" }}
                format="DD/MM/YYYY hh:mm A" // dd/MM/yyyy format with time in 12-hour format
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
              />
            </Form.Item>

            <Form.Item
              label={
                <div className="flex w-full">
                  <div>Address</div>
                  <div className="ml-[.5rem]">
                    <Tooltip title="Add Address">
                      <PlusCircleOutlined onClick={setShowAddressModal} />
                    </Tooltip>
                  </div>
                </div>
              }
              name="location"
              rules={[{ required: true, message: "Please select a location" }]}
            >
              <Select placeholder="Select a location">
                {customerData?.location?.map((location) => (
                  <Select.Option key={location?.id} value={location?.id}>
                    {`${location?.house_flat_floor_no}, ${location?.apartment_road_area}, ${location?.city?.name}, ${location.state.name}, ${location.country.name} - ${location?.pincode?.pin}`}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="coupon" label={"Apply Coupon"}>
              <Select placeholder="Select Coupon" onChange={handleSelectCoupon}>
                {coupons?.data?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item?.code}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="amount"
              label="Total amount as per order item selected"
            >
              <Input disabled placeholder="total amount of order items" />
            </Form.Item>

            <Form.Item>
              <div style={{ textAlign: "center" }}>
                <Space>
                  <Button type="primary" htmlType="submit">
                    {isEditMode ? "Update" : "Pay On Service"}
                  </Button>
                  <Button onClick={handleCancel}>Cancel</Button>
                </Space>
              </div>
            </Form.Item>
          </Form>
        ) : (
          <>
            <div>Total Order: {dataSourceOrder?.length}</div>
            <Table
              dataSource={dataSourceOrder?.sort(
                (a, b) =>
                  new Date(b.place_datetime) - new Date(a.place_datetime)
              )}
              columns={[
                {
                  title: "Order Number",
                  dataIndex: "order_number",
                  key: "order_number",
                  fixed: "left",
                  ...getColumnSearchProps("order_number"),
                  // render: (orderNumber) => <Tag>{orderNumber}</Tag>,
                },
                {
                  title: "Customer",
                  dataIndex: "customer",
                  key: "customer",
                  ...getColumnSearchProps("customer"), // Use "full_name" for proper searching
                  // render: (customer) => {
                  //   const fullName = `${customer.first_name} ${
                  //     customer.middle_name ?? ""
                  //   } ${customer.last_name}`.trim();
                  //   return fullName;
                  // },
                },
                {
                  title: "Status",
                  dataIndex: "order_status",
                  key: "order_status",
                  // render: (status) => (status ? <Tag>{status}</Tag> : null),
                },
                {
                  title: "Place Date-Time",
                  dataIndex: "place_datetime",
                  key: "place_datetime",
                  render: (placeDateTime) => {
                    const { formattedDate, formattedTime } =
                      formatDateTime(placeDateTime);
                    return (
                      <div>
                        <Tag>{formattedDate}</Tag>
                        <Tag>{formattedTime}</Tag>
                      </div>
                    );
                  },
                },
                {
                  title: "Schedule Date-Time",
                  dataIndex: "schedule_datetime",
                  key: "schedule_datetime",
                  render: (scheduleDateTime, record) => {
                    // Use schedule_datetime if available; otherwise, fall back to place_datetime
                    const datetimeToFormat =
                      scheduleDateTime || record.place_datetime;
                    const { formattedDate, formattedTime } =
                      formatDateTime(datetimeToFormat);

                    return (
                      <div>
                        <Tag>{formattedDate}</Tag>
                        <Tag>{formattedTime}</Tag>
                      </div>
                    );
                  },
                },
                {
                  title: "Address",
                  dataIndex: "location",
                  key: "location",

                  // render: (location) => (
                  //   <Tooltip
                  //     title={
                  //       <>
                  //         {" "}
                  //         <Tag>{location.address_identifier}</Tag>
                  //         <br />
                  //         <br />
                  //         {location.house_flat_floor_no}-
                  //         {location.apartment_road_area}
                  //         <br />
                  //         {location.city.name}-{location.state.name}
                  //         <br />
                  //         {location.pincode?.pin}-{location.country.name}
                  //       </>
                  //     }
                  //   >
                  //     <Tag>Address</Tag>
                  //   </Tooltip>
                  // ),
                },
                {
                  title: "OTP",
                  dataIndex: "otp",
                  key: "otp",
                  // render: (otp) => <Tag color="blue">{otp}</Tag>,
                },
                {
                  title: "Point of Contact",
                  dataIndex: "point_of_contact_search", // Search by both name and phone
                  key: "point_of_contact_search",
                  ...getColumnSearchProps("point_of_contact_search"), // Make both searchable
                  // render: (_, record) => record.point_of_contact, // Render JSX for display
                },
                {
                  title: "Order Item",
                  dataIndex: "order_item",
                  key: "order_item",
                  // render: (orderItems) => (
                  //   <Button onClick={() => handleViewOrderItems(orderItems)}>
                  //     View Order Item
                  //   </Button>
                  // ),
                  render: (_, record) => (
                    <Button
                      onClick={() =>
                        handleViewOrderItems(
                          record?.id,
                          record?.order_number,
                          record.order_item
                        )
                      }
                    >
                      View Order Item
                    </Button>
                  ),
                },
                {
                  title: "Invoice",
                  key: "transactions",
                  dataIndex: "transactions",
                  render: (transactions) =>
                    transactions?.length !== 0 ? (
                      <Button
                        type="primary"
                        ghost
                        // onClick={() => openInvoicePDF(transactions)}
                        onClick={() => handleViewInvoice(transactions)}
                      >
                        View
                      </Button>
                    ) : (
                      <Tag>Not Paid</Tag>
                    ),
                },
                {
                  title: "Action",
                  key: "action",
                  render: (_, record) => (
                    <Button
                      type="link"
                      onClick={() => {
                        handleEdit(record);
                      }}
                    >
                      <EditOutlined />
                    </Button>
                  ),
                },
                {
                  title: "Cancelled Date Time",
                  dataIndex: "cancelled_date_time",
                  key: "cancelled_date_time",
                  render: (cancelled_date_time, record) => {
                    if (cancelled_date_time) {
                      const { formattedDate, formattedTime } =
                        formatDateTime(cancelled_date_time);
                      return (
                        <div>
                          <Tag>{formattedDate}</Tag>
                          <Tag>{formattedTime}</Tag>
                        </div>
                      );
                    } else {
                      return <span>-</span>;
                    }
                  },
                },
                {
                  title: "Cancelled By",
                  dataIndex: "cancelled_by",
                  key: "cancelled_by",
                },
                {
                  title: "Cancel Order/Reason",
                  key: "cancel",
                  render: (_, record) => {
                    const { cancellation_reason, order_status, id } = record;
                    const isCancellable = [
                      "pending",
                      "accepted",
                      "reached",
                    ].includes(order_status);

                    if (cancellation_reason === null) {
                      return isCancellable ? (
                        <Button
                          type="primary"
                          onClick={() => {
                            setSelectedOrderId(id);
                            setIsCancelOrderModalVisible(true);
                          }}
                        >
                          Cancel
                        </Button>
                      ) : (
                        "Cannot be cancelled"
                      );
                    } else {
                      return (
                        <span className="trunc w-[.5rem]">
                          {cancellation_reason}
                        </span>
                      );
                    }
                  },
                },
              ]}
            />
          </>
        )}

        <Modal
          title="Create Order Item"
          visible={isModalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          okText="Create"
          cancelText="Cancel"
          footer={false}
        >
          <OrderItems
            customerData={customerData}
            setIsModalVisible={setIsModalVisible}
            fetchCustomerData={fetchCustomerData}
          />
        </Modal>

        <Modal
          title="Create Address"
          visible={showAddressModal}
          onOk={handleAdressModalOk}
          onCancel={handleAddressModalCancel}
          okText="Create"
          cancelText="Cancel"
          footer={false}
        >
          <CustomerAddress
            handleAddressModalCancel={handleAddressModalCancel}
            handleAdressModalOk={handleAdressModalOk}
            selectedCustomerProfile={selectedCustomerProfile}
          />
        </Modal>
        {/*  */}

        <Modal
          title="Order Items"
          visible={viewOrderItemsModalVisible}
          onCancel={closeOrderItemsModal}
          footer={false}
          width={800}
        >
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={{ pageSize: 5 }}
            locale={{ emptyText: "No order items available for this order." }}
          />
        </Modal>

        <Modal
          title="Cancel Order"
          visible={cancelOrderModalVisible}
          onOk={handleCancelOrder}
          onCancel={() => {
            setIsCancelOrderModalVisible(false);
            setCancellationReason("");
          }}
          okText="Submit"
          cancelText="Close"
        >
          <p>Please provide a reason for cancelling this order:</p>
          <Input.TextArea
            value={cancellationReason}
            onChange={(e) => setCancellationReason(e.target.value)}
            rows={4}
          />
        </Modal>

        <Modal
          title="Invoice"
          visible={invoiceModalVisible}
          onOk={handleInvoiceModalOk}
          onCancel={() => {
            handleInvoiceModalClose(false);
          }}
          // okText="Submit"
          // cancelText="Close"
          footer={false}
          width={600}
        >
          <PDFViewer
            pdfUrl={selectedTransactions?.transactions?.[0]?.invoice_pdf}
            baseUrl={baseUrl}
            prodTestUrl={prodTestUrl}
          />
        </Modal>
        <Modal
          title="Create Point Of Contact"
          visible={isPOCModalVisible}
          onOk={handleModalOk}
          onCancel={handlePOCModalCancel}
          okText="Create"
          cancelText="Cancel"
          footer={false}
        >
          <PointOfContact
            customers={customers}
            setSelectedCustomerProfile={setSelectedCustomerProfile}
            prodTestUrl={prodTestUrl}
            baseUrl={baseUrl}
            fetchCustomerData={fetchCustomerData}
            setIsPOCModalVisible={setIsPOCModalVisible}
            customerData={customerData}
          />
        </Modal>
      </div>
    </Spin>
  );
};

export default Order;
